import { Col, QRCode, Row, Typography } from 'antd';
import { ModalTheme } from '../../../../components/modal';
import { color } from '../../../../resources';

export const QqClaimCode = ({ open, onToggle, item }) => {
  const showClaimType = item?.channelClaimCode === 'FOCUS';
  const claimCode = item && item?.claimCode ? item?.claimCode : '-';
  const storeName = item && item?.storeName ? item?.storeName : '-';
  const storePhoneNumber = item && item?.storePhoneNumber ? item?.storePhoneNumber : '-';
  const bookingDate = item && item?.bookingDate ? item?.bookingDate : '-';
  const shopLocation = item && item?.shopLocation ? item?.shopLocation : '-';
  const isShopLocationUrl =
    shopLocation !== '-' &&
    (shopLocation.startsWith('http://') || shopLocation.startsWith('https://'));
  return (
    <ModalTheme title=" " open={open} onToggle={onToggle}>
      <Row justify="center" align="middle">
        <Col span={24} style={{ textAlign: 'center' }}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <QRCode value={claimCode} width={100} />
            <h3 style={{ opacity: 0.5, marginTop: '8px' }}>{claimCode}</h3>
            <h3>สามารถนำ QR code ไปรับสินค้าเคลม</h3>
            <h3>ที่ร้าน: {storeName}</h3>
            {showClaimType && <h3 style={{ color: color.blueFocus }}>ในวันที่: {bookingDate}</h3>}
            <h3 style={{ color: color.blueFocus }}>ติดต่อ: {storePhoneNumber}</h3>
            <h3 style={{ color: color.red }}>
              **กรุณาเข้ารับบริการภายใน 3 วัน หลังจากวันที่นัดหมาย หากเลยวันที่นัดหมายไว้
              กรุณาจองวันนัดใหม่อีกครั้ง{' '}
            </h3>
            <h3 style={{ color: color.blueFocus }}>
              พิกัดร้าน:{' '}
              {isShopLocationUrl ? (
                <Typography.Link
                  href={shopLocation}
                  target="_blank"
                  rel="noopener noreferrer"
                  underline
                >
                  ดูแผนที่
                </Typography.Link>
              ) : (
                shopLocation
              )}
            </h3>
          </div>
        </Col>
      </Row>
    </ModalTheme>
  );
};
